import { ReactNode, memo } from 'react';

export const MenuGroup = memo(({ children }: { children: ReactNode }) => {
  return <div className="py-4 px-1 space-y-3">{children}</div>;
});
